import moment from 'moment-timezone';
import Act from '../../../../shared/domain/activity/act/model/Act';

const ANNEXE_29_MODIFICATIONS_DATE = moment('2026-03-23');

const DAY_INTENSIVE_CARE_SUPPORT_CODES = ['9294', '9295', '15950'];
const EVENING_INTENSIVE_CARE_SUPPORT_CODES = ['15951', '42420', '42421'];
const NIGHT_INTENSIVE_CARE_SUPPORT_CODES = ['15952', '42422', '42423'];

const INTENSIVE_CARE_SUPPORT_CODES = [
  ...DAY_INTENSIVE_CARE_SUPPORT_CODES,
  ...EVENING_INTENSIVE_CARE_SUPPORT_CODES,
  ...NIGHT_INTENSIVE_CARE_SUPPORT_CODES
];

const intensiveCareSupportCodesValidation = ({ codes, date, start }: Act) => {
  if (moment(date).isBefore(ANNEXE_29_MODIFICATIONS_DATE)) return {};

  if (!start) return {};

  const startTime = moment(start);
  const startHour = startTime.hour();

  const billedIntensiveCareSupportCodes = codes.filter((code) => INTENSIVE_CARE_SUPPORT_CODES.includes(code.code));
  if (billedIntensiveCareSupportCodes.length === 0) return;

  const intensiveCareSupportCodesErrorMessages: Record<string, string> = {};

  const daySupportCode = billedIntensiveCareSupportCodes.find((code) =>
    DAY_INTENSIVE_CARE_SUPPORT_CODES.includes(code.code)
  );
  if (daySupportCode && (startHour < 7 || startHour >= 19)) {
    return {
      codes: {
        _error: `Le forfait de prise en charge d'unité de soins intensifs ${daySupportCode.code} doit être facturé la journée (entre 7h et 19h)`
      }
    };
  }

  const eveningSupportCode = billedIntensiveCareSupportCodes.find((code) =>
    EVENING_INTENSIVE_CARE_SUPPORT_CODES.includes(code.code)
  );
  if (eveningSupportCode && startHour < 19) {
    return {
      codes: {
        _error: `Le forfait de prise en charge d'unité de soins intensifs ${eveningSupportCode.code} doit être facturé en soirée (après 19h)`
      }
    };
  }

  const nightSupportCode = billedIntensiveCareSupportCodes.find((code) =>
    NIGHT_INTENSIVE_CARE_SUPPORT_CODES.includes(code.code)
  );
  if (nightSupportCode && startHour >= 7) {
    return {
      codes: {
        _error: `Le forfait de prise en charge d'unité de soins intensifs ${nightSupportCode.code} doit être facturé la nuit (avant 7h)`
      }
    };
  }

  if (billedIntensiveCareSupportCodes.length > 1) {
    return {
      codes: {
        _error: `Un seul forfait de prise en charge d'unité de soins intensifs est permis. (${billedIntensiveCareSupportCodes.map((code) => code.code).join(', ')})`
      }
    };
  }

  return intensiveCareSupportCodesErrorMessages;
};

export default intensiveCareSupportCodesValidation;
